<template>
	<CRow>
		<CCol col="12">
			<CCard>
				<CCardHeader>(COLIKADO) - Résumé de la journée par type de produit</CCardHeader>
				<CCardBody>
					<CRow>
						<CCol col="4">
							<vc-date-picker
								v-model="startDate"
								mode="date"
								timezone="UTC"
								:model-config="datepickerConfig">
								<template v-slot="{ inputValue, inputEvents }">
									<CInput
										label="Date de départ"
										type="text"
										:value="inputValue"
										v-on="inputEvents" />
								</template>
							</vc-date-picker>
						</CCol>

						<CCol col="4">
							<vc-date-picker
								v-model="endDate"
								mode="date"
								timezone="UTC"
								:model-config="datepickerConfig">
								<template v-slot="{ inputValue, inputEvents }">
									<CInput
										label="Date de fin"
										type="text"
										:value="inputValue"
										v-on="inputEvents" />
								</template>
							</vc-date-picker>
						</CCol>

						<CCol col="4" class="d-inline-flex">
							<GLoadingButton
								:loading="loading"
								@click="getSummary"
								class="mt-4"
								label="Rechercher" />
						</CCol>
					</CRow>

					<CCol col="12" class="mt-5">
						<h3 class="text-center">
							Résumé du {{ $moment(startDate).format('DD/MM/YYYY') }} -
							{{ $moment(endDate).format('DD/MM/YYYY') }}
						</h3>
						<div class="table-responsive">
							<table class="table table-bordered col-sm-12 mt-3">
								<thead>
									<tr>
										<th scope="col">Produit</th>
										<th scope="col">Quantité</th>
										<th scope="col">Etq Imprimées</th>
										<th scope="col">Etq Non-Imprimées</th>
										<th scope="col">Poids</th>
										<th scope="col">Volume</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(o, i) in data" :key="i">
										<td>{{ i }}</td>
										<td>{{ o.quantity }}</td>
										<td>{{ o.quantityLabelGenerated }}</td>
										<td>{{ o.quantityLabelNotGenerated }}</td>
										<td>{{ $numeral(o.weight).format('0,0.00') }} KG</td>
										<td>{{ $numeral(o.volume).format('0,0.00') }}</td>
									</tr>
									<tr>
										<td class="font-weight-bold">TOTAL</td>
										<td>{{ totalQuantity }}</td>
										<td>{{ totalQuantityLabelGenerated }}</td>
										<td>{{ totalQuantityLabelNotGenerated }}</td>
										<td>{{ $numeral(totalWeight).format('0,0.00') }} KG</td>
										<td>{{ $numeral(totalVolume).format('0,0.00') }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</CCol>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
	import mercure from '../../components/ghostlexly-components/libs/mercure';
	import GLoadingButton from '@/components/ghostlexly-components/GLoadingButton';

	export default {
		name: 'colikado-summary-by-product-type',
		components: { GLoadingButton },
		data() {
			return {
				datepickerConfig: {
					type: 'string',
					mask: 'YYYY-MM-DD',
				},
				startDate: this.$moment().format('YYYY-MM-DD'),
				endDate: this.$moment().format('YYYY-MM-DD'),
				data: [],
				loading: false,
			};
		},

		computed: {
			totalQuantity() {
				let total = 0;

				for (let item of Object.values(this.data)) {
					total += item.quantity;
				}

				return total;
			},

			totalQuantityLabelGenerated() {
				let total = 0;

				for (let item of Object.values(this.data)) {
					total += item.quantityLabelGenerated;
				}

				return total;
			},

			totalQuantityLabelNotGenerated() {
				let total = 0;

				for (let item of Object.values(this.data)) {
					total += item.quantityLabelNotGenerated;
				}

				return total;
			},

			totalWeight() {
				let total = 0;

				for (let item of Object.values(this.data)) {
					total += item.weight;
				}

				return total;
			},

			totalVolume() {
				let total = 0;

				for (let item of Object.values(this.data)) {
					total += item.volume;
				}

				return total;
			},
		},

		methods: {
			getSummary() {
				this.loading = true;

				let params = new URLSearchParams();
				params.append('startDate', this.startDate + 'T00:00:00.000Z');
				params.append('endDate', this.endDate + 'T23:59:59.999Z');
				params.append('concept', 'order.colikado');

				this.$axios
					.get(`/api/order_items/stats/product_type?${params.toString()}`)
					.then(res => {
						this.loading = false;
						this.data = res.data;
					})
					.catch(err => {
						this.loading = false;
						this.$toast.error('Une erreur est survenue.');
					});
			},
		},
		mounted() {
			this.getSummary();
		},
	};
</script>
